import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UiModule } from '../../../../components/ui.module';
import { Branch } from '../../../../types';

type CellParams = ICellRendererParams<Branch> & {
  addCallback: (item: Branch) => void;
};

@Component({
  selector: 'app-pan-cell-locationgroup-list-header-actions',
  imports: [UiModule, MatTooltipModule, RouterModule],
  templateUrl: './cell-locationgroup-list-header-actions.component.html',
  styleUrl: './cell-locationgroup-list-header-actions.component.scss',
})
export class CellLocationGroupListHeaderActionsComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
